var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 7.3125L15.625 1.375M15.625 1.375H11.6667M15.625 1.375V5.33333M15.625 10.0833V14.0417C15.625 14.4616 15.4582 14.8643 15.1613 15.1613C14.8643 15.4582 14.4616 15.625 14.0417 15.625H2.95833C2.53841 15.625 2.13568 15.4582 1.83875 15.1613C1.54181 14.8643 1.375 14.4616 1.375 14.0417V2.95833C1.375 2.53841 1.54181 2.13568 1.83875 1.83875C2.13568 1.54181 2.53841 1.375 2.95833 1.375H6.91667",
    stroke: "#034A73",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBlue);
export default __webpack_public_path__ + "static/media/upload_blue.7f401803b31bb886876a8383dbd8bc5b.svg";
export { ForwardRef as ReactComponent };